export enum OrderBy {
  "Terbaru" = 0,
  "Terupdate" = 1,
  "Termurah" = 2,
  "Termahal" = 3,
}
